import { i18n } from '../../i18n';
import { request } from 'beans-admin-plugin';



export const filterColumnsHash = {
  title_cont: {
    label: i18n.t('category.title'),
    renderCell: {
      component: 'input'
    }
  },
  parent_id_eq: {
    label: i18n.t('category.parent'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        xRemotePreload: async () => {
          const { data } = await request.get('/categories', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.title }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { title_cont: keyword };
          const { data } = await request.get('/categories', { params });
          return data.map(item => ({ value: item.id, label: item.title }));
        }
      }
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('category.id'),
    width: 80,
  },
  position: {
    label: i18n.t('category.position'),
  },
  title: {
    label: i18n.t('category.title'),
  },
  parent_id: {
    label: i18n.t('category.parent'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.parent) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'parents.show', params: { id: row.parent_id } }}>{row.parent.title}</bean-link>
    },
  },
  created_at: {
    label: i18n.t('category.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('category.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  image: {
    label: i18n.t('category.image'),
    width: 120,
    renderCell: 'storageAttachment',
  },
}

export const formColumnsHash = {
  position: {
    label: i18n.t('category.position'),
    renderCell: {
      component: 'input',
    },
  },
  title: {
    label: i18n.t('category.title'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  parent_id: {
    label: i18n.t('category.parent'),
    renderCell: {
      component: 'select',
      props: {
        xRemotePreload: async () => {
          const { data } = await request.get('/categories', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.title }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { title_cont: keyword };
          const { data } = await request.get('/categories', { params });
          return data.map(item => ({ value: item.id, label: item.title }));
        }
      }
    }
  },
  image: {
    label: i18n.t('category.image'),
    width: 120,
    renderCell: {
      required: true,
      component: 'upload',
    }
  },
}
